import {Table} from "./table";

export const Groups = () => {
    return (
        <>
            <Table/>
        </>
    )
}